module.exports = __webpack_public_path__ + "img/logo14.508e982e.png";